import * as React from 'react';
import {
  Box, Card, CardContent, createStyles,
  Grid, makeStyles, Paper, Typography,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import ErrorIcon from '@material-ui/icons/Error';
import type IBox from '../receiving/ReceivingInterfaces';

const useStyles = makeStyles(() => createStyles({
  root: {
    flexGrow: 1,
  },
  boxCount: {
    width: '20px',
    height: '20px',
    backgroundColor: '#F2F2F2',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '4px',
  },
  boxCountText: {
    fontWeight: 700,
  },
  trackingNumberText: {
    fontWeight: 500,
  },
  dot: {
    height: '6px',
    width: '6px',
    borderRadius: '50%',
    display: 'inline-block',
    marginBottom: '2px',
  },
  boxIcon: {
    fontSize: '18px',
  },
  boxTitle: {
    fontSize: '18px', fontWeight: 700,
  },
  cardContent: {
    paddingRight: '4px',
  },
}));
interface CompletedShipmentsProps {
  completedShipments: Array<IBox>;
  boxType: 'duplicate' | 'highpriority'
}

const SpecialCaseBoxes: React.FC<CompletedShipmentsProps> = ({ completedShipments, boxType }) => {
  const theme = useTheme();
  const classes = useStyles();
  const boxTypeCount = completedShipments.filter((x) => (boxType === 'highpriority' ? (x.isRush) : (x.isDuplicate))).length;

  return (
    <>
      {boxTypeCount > 0 && (
        <Box px={2}>
          <Grid container spacing={0}>
            <Grid item xs={1}>
              <span className={classes.dot} style={{ backgroundColor: boxType === 'highpriority' ? theme.palette.error.main : 'orange' }} />
            </Grid>
            <Grid item xs={10}>
              <Typography variant="subtitle2" className={classes.boxTitle}>
                {boxType === 'highpriority' ? 'High Priority Boxes' : 'Duplicate Boxes'}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Paper className={classes.boxCount} elevation={0}>
                <Typography variant="body2" className={classes.boxCountText}>
                  {boxTypeCount}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
          <Box paddingBottom={1} />

          <Grid container>
            {completedShipments.filter((x) => (boxType === 'highpriority' ? (x.isRush) : (x.isDuplicate))).map((completedShipment) => (
              <>
                <Grid item xs={1} />
                <Grid item xs={11}>
                  <Card key={completedShipment.trackingNumber}>
                    <CardContent className={classes.cardContent}>
                      <Grid container spacing={0}>
                        <Grid item xs={11}>
                          <Typography variant="body1" color="primary" className={classes.trackingNumberText}>
                            {completedShipment.trackingNumber}
                          </Typography>
                        </Grid>
                        <Grid item xs={1}>
                          {
                            boxType === 'highpriority'
                              ? <ErrorIcon color="error" className={classes.boxIcon} />
                              : <AddCircleIcon htmlColor="orange" className={classes.boxIcon} />
                          }
                        </Grid>
                      </Grid>
                      {boxType === 'highpriority' && completedShipment?.urgentNote?.map((urgentNote) => (
                        <Typography variant="body2" color="textSecondary">{urgentNote}</Typography>
                      ))}
                      <Typography variant="body2" color="textSecondary">{completedShipment.client}</Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Box paddingTop={2} />
                </Grid>
              </>
            ))}
          </Grid>
        </Box>
      )}
    </>

  );
};

export default SpecialCaseBoxes;
